/**
 * @file getter
 */
export function menuList(state) {
    return state.menuList;
}

export function cityList(state) {
    return state.cityList;
}